import styled from 'styled-components';
import { Button } from '@material-ui/core';

export const CopyButton = styled(Button)`
  && {
    min-width: 0;
  }
`;
